var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "group-page-menu-actions" },
    _vm._l(_vm.actions, function (action) {
      return _c(
        "div",
        {
          key: action.id,
          staticClass: "row group-page-menu-action",
          class: { "group-page-menu-action_active": action.active },
          attrs: { "aria-label": action.label, tabindex: "0" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.onActionClick(action)
            },
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.onActionClick(action)
            },
          },
        },
        [
          _c("div", { staticClass: "col-xs-12 margin-5-top margin-5-bottom" }, [
            _c(
              "span",
              {
                staticClass: "group-page-menu-action__icon text-center",
                class: action.iconType === "fa" ? undefined : action.iconClass,
              },
              [
                action.iconType === "fa"
                  ? _c("i", {
                      class: action.iconClass,
                      staticStyle: {
                        "font-size": "29px",
                        "line-height": "36px",
                      },
                    })
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "group-page-menu-action__text" }, [
              _vm._v(_vm._s(action.label)),
            ]),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }